// Helpers et composants de champs partages par les wizards VGP et CT.

export const CHAMPS_TRONC = [
  "numero_controle", "date_controle", "heure_controle", "kilometrage_releve",
  "controleur_nom", "controleur_prenom", "controleur_entreprise", "cachet_entreprise",
  "conclusion", "validite_mois",
];

export const VERDICTS = [
  "L'appareil peut être utilisé",
  "L'appareil ne peut pas être utilisé",
];

// Le champ `conclusion` (Text) porte le verdict + un commentaire optionnel sur
// la ligne suivante. encode/decode assurent un aller-retour fiable.
export function encoderConclusion(verdict, commentaire) {
  if (!verdict) return commentaire || "";
  return commentaire ? `${verdict}\n${commentaire}` : verdict;
}

export function decoderConclusion(conclusion) {
  if (!conclusion) return { verdict: "", commentaire: "" };
  for (const v of VERDICTS) {
    if (conclusion === v) return { verdict: v, commentaire: "" };
    if (conclusion.startsWith(v + "\n")) {
      return { verdict: v, commentaire: conclusion.slice(v.length + 1) };
    }
  }
  return { verdict: "", commentaire: conclusion };
}

export const nettoyerEntier = (s) => String(s ?? "").replace(/[^0-9]/g, "");

export function nettoyerDecimal(s) {
  let v = String(s ?? "").replace(",", ".").replace(/[^0-9.]/g, "");
  const i = v.indexOf(".");
  if (i !== -1) v = v.slice(0, i + 1) + v.slice(i + 1).replace(/\./g, "");
  return v;
}

export const estVide = (v) => v === "" || v === null || v === undefined;

// Options d'enum (valeurs = celles attendues par le backend).
export const OPT_MARQUAGE = [
  { valeur: "ce", label: "CE" },
  { valeur: "sans", label: "Sans" },
];
export const OPT_BON_DEFAUT = [
  { valeur: "bon", label: "Bon" },
  { valeur: "defaut", label: "Défaut" },
];
export const OPT_BON_DEFAUT_SO = [
  { valeur: "bon", label: "Bon" },
  { valeur: "defaut", label: "Défaut" },
  { valeur: "so", label: "S.O." },
];

export function libelleOption(valeur, options) {
  const o = options.find((x) => x.valeur === valeur);
  return o ? o.label : null;
}

export const afficheOuiNon = (v) => (v === true ? "Oui" : v === false ? "Non" : null);

// --- Composants de champs -------------------------------------------------

// Champ en lecture seule (pre-remplissage / recapitulatif). Signale un vide.
export function ChampLecture({ label, valeur }) {
  const vide = valeur === null || valeur === undefined || valeur === "";
  return (
    <div className="champ">
      <span className="champ-label">{label}</span>
      <span className={"champ-valeur" + (vide ? " champ-manquant" : "")}>
        {vide ? "Non renseigné" : String(valeur)}
      </span>
    </div>
  );
}

// Ligne de checklist : libelle a gauche, choix radio inline a droite.
export function LigneChoix({ label, name, valeur, options, onChange, ro }) {
  return (
    <div className="ligne-checklist">
      <span className="checklist-label">{label}</span>
      <div className="options-inline">
        {options.map((o) => (
          <label key={String(o.valeur)} className="option-radio">
            <input
              type="radio"
              name={name}
              checked={valeur === o.valeur}
              disabled={ro}
              onChange={() => onChange(o.valeur)}
            />
            {o.label}
          </label>
        ))}
      </div>
    </div>
  );
}

const OUI_NON = [
  { valeur: true, label: "Oui" },
  { valeur: false, label: "Non" },
];

export function CaseOuiNon({ label, name, valeur, onChange, ro }) {
  return (
    <LigneChoix label={label} name={name} valeur={valeur} options={OUI_NON} onChange={onChange} ro={ro} />
  );
}

// Case a cocher simple (booleen present/absent).
export function CaseACocher({ label, checked, onChange, ro }) {
  return (
    <label className="ligne-checklist ligne-case">
      <span className="checklist-label">{label}</span>
      <input
        type="checkbox"
        checked={checked === true}
        disabled={ro}
        onChange={(e) => onChange(e.target.checked)}
      />
    </label>
  );
}
